(() => {
 const form = document.querySelector('#LaunchSignup');
 if (!form) return;
 const params = new URLSearchParams(location.search);
 const tags = form.querySelector('[name="contact[tags]"]');
 // Keep attribution non-identifying; no email is sent to analytics.
 const allowed = ['utm_source','utm_medium','utm_campaign','utm_content','r3vy_campaign_id','r3vy_content_id'];
 const attribution = {};
 allowed.forEach(key => {
  const value = params.get(key);
  if (value && /^[a-zA-Z0-9_.-]{1,80}$/.test(value)) {
   attribution[key] = value;
   if(tags) tags.value += ',' + key + ':' + value;
  }
 });
 form.addEventListener('submit', () => {
  if (!form.checkValidity()) return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({event:'gbd_launch_signup_submit',campaign_id:'gbd-coming-soon-202609',content_id:'sunrise-v1',...attribution});
 });
 const success = form.querySelector('.signup-success');
 if (success) {
  success.focus();
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({event:'gbd_launch_signup_success',campaign_id:'gbd-coming-soon-202609',content_id:'sunrise-v1'});
 }
})();

(() => {
 const dialog = document.querySelector('#InvestorEnquiry');
 const opener = document.querySelector('.investor-open');
 const form = document.querySelector('#InvestorForm');
 if (!dialog || !opener || !form) return;
 opener.addEventListener('click', () => dialog.showModal());
 dialog.querySelector('.investor-close').addEventListener('click', () => dialog.close());
 dialog.addEventListener('close', () => opener.focus());
 dialog.addEventListener('click', event => {
  const rect = dialog.getBoundingClientRect();
  if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
 });
 form.addEventListener('submit', async event => {
  event.preventDefault();
  if (!form.reportValidity()) return;
  const button = form.querySelector('button[type="submit"]');
  const error = dialog.querySelector('#InvestorError');
  button.disabled = true; button.textContent = 'Sending…'; error.hidden = true;
  try {
   const response = await fetch('https://r3vy.com/api/public/investor-enquiries', {
    method:'POST', headers:{'Content-Type':'application/json'},
    body:JSON.stringify(Object.fromEntries(new FormData(form))),
    signal:AbortSignal.timeout(20000), credentials:'omit'
   });
   const result = await response.json();
   if (!response.ok || !result.ok) throw new Error(result.error || "We couldn't save your enquiry. Please try again.");
   form.hidden = true;
   const success = dialog.querySelector('#InvestorSuccess'); success.hidden = false; success.focus();
  } catch (err) {
   error.textContent = err.name === 'TimeoutError' || err instanceof TypeError ? "We couldn't connect. Please try again, or email hello@greatbrainday.com." : err.message;
   error.hidden = false;
  } finally { button.disabled = false; button.textContent = "Let's talk ↗"; }
 });
})();
